import React, { useEffect, useState } from "react";

let idSeq = 1;

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};
      const toast = {
        id: idSeq++,
        message: String(detail.message || ""),
        type: detail.type || "success", // success | error | info
        duration: Number(detail.duration || 2500),
      };
      setToasts((list) => [...list, toast]);
      // auto-dismiss
      setTimeout(() => {
        setToasts((list) => list.filter((t) => t.id !== toast.id));
      }, toast.duration);
    };
    window.addEventListener("toast:show", handler);
    return () => window.removeEventListener("toast:show", handler);
  }, []);

  const getColors = (type) => {
    switch (type) {
      case "error":
        return { bg: "#ffebee", fg: "#c62828", border: "#ef9a9a" };
      case "info":
        return { bg: "#e3f2fd", fg: "#1565c0", border: "#90caf9" };
      case "success":
      default:
        return { bg: "#e8f5e9", fg: "#2e7d32", border: "#a7d7ad" };
    }
  };

  if (!toasts.length) return null;

  return (
    <div
      style={{
        position: "fixed",
        right: 12,
        bottom: 12,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        zIndex: 9999,
        pointerEvents: "none",
      }}
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((t) => {
        const { bg, fg, border } = getColors(t.type);
        return (
          <div
            key={t.id}
            role="status"
            style={{
              pointerEvents: "auto",
              background: bg,
              color: fg,
              border: `1px solid ${border}`,
              borderRadius: 8,
              padding: "10px 14px",
              minWidth: 200,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              font: "400 14px Roboto, -apple-system, Helvetica, sans-serif",
            }}
          >
            {t.message}
          </div>
        );
      })}
    </div>
  );
}
